











































import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import _orderBy from 'lodash/orderBy'

import SourceDetailOverlay from '@/components/overlays/SourceDetailOverlay.vue'
import { IImage } from '@/models'
import _filter from 'lodash/filter'

@Component( {
    components: {
        'oe-source-detail-overlay': SourceDetailOverlay
    },
    computed: mapGetters( {
        images: 'imagesModule/images',
        totalImages: 'imagesModule/totalImages',
        associationById: 'associationsModule/associationById',
        formattedDate: 'globalModule/formattedDate'
    } )
} )
export default class ImagesView extends Vue {
    $refs!: {
       sourceDetailOverlay: SourceDetailOverlay;
    }
    orderFilter = 'votes'
    images!: any
    associationById!: any

    get orderedImages() {
        switch ( this.orderFilter ) {
            case 'date':
                return _orderBy( this.images, [( o ) => o.datePublished.seconds], ['desc'] )
            case 'votes':
                return _orderBy( this.images, [( o ) => o.relatedAssociations.length], ['desc'] )
            default:
                return _orderBy( this.images, 'dateCreated', 'desc' )
        }
    }

    get filteredAssociations() {
        return ( image: IImage ) => {
            return _filter( image.relatedAssociations, ( association ) => {
                if ( this.associationById( association ) ) {
                    return this.associationById( association ).language === this.$i18n.locale
                        && this.associationById( association ).published
                        && this.associationById( association ).relatedImage === image.id
                }
            } )
        }
    }

    showSourceDetail( image: IImage ) {
        this.$store.commit( 'imagesModule/setCurrentImage', image.id )
        this.$refs.sourceDetailOverlay.showOverlay()
    }

    loadMore() {
        console.log( 'Load more...' )
    }
}
